(function () {
    window.ingridFilters = window.ingridFilters || {};
  
    function facetCheckboxForValue(value, paramName) {
      let inputs = document.querySelectorAll('input.checkbox__input, input.facets__pill-input');
      for (let i = 0; i < inputs.length; i++) {
        if (paramName && inputs[i].name !== paramName) continue;
        if (inputs[i].value === value && !inputs[i].disabled) return inputs[i];
      }
      return null;
    }
  
    function normalizePriceParam(value) {
      if (value == null || value === '') return '';
      return String(value).replace(/,/g, '').split('.')[0];
    }
  
    function applyPriceSlab(filterElement) {
      let gte = filterElement.getAttribute('data-price-gte') || '';
      let lte = filterElement.getAttribute('data-price-lte') || '';
      let isActive = filterElement.classList.contains('activeFilter');
  
      let url = new URL(window.location.href);
      url.searchParams.delete('filter.v.price.gte');
      url.searchParams.delete('filter.v.price.lte');
      url.searchParams.delete('page');
  
      if (!isActive) {
        if (gte !== '') url.searchParams.set('filter.v.price.gte', gte);
        if (lte !== '') url.searchParams.set('filter.v.price.lte', lte);
      }
  
      let facetsForm = document.querySelector('facets-form-component');
      if (facetsForm && typeof facetsForm.updateFiltersByURL === 'function') {
        facetsForm.updateFiltersByURL(url.toString());
        return;
      }
  
      window.location.href = url.toString();
    }
  
    function syncPriceSlabActiveState() {
      let url = new URL(window.location.href);
      let currentGte = normalizePriceParam(url.searchParams.get('filter.v.price.gte'));
      let currentLte = normalizePriceParam(url.searchParams.get('filter.v.price.lte'));
  
      document.querySelectorAll('.ingrid-filters-container .quickFilter[data-price-slab="true"]').forEach(function (el) {
        let gte = normalizePriceParam(el.getAttribute('data-price-gte'));
        let lte = normalizePriceParam(el.getAttribute('data-price-lte'));
        let matches = currentGte === gte && currentLte === lte;
        el.classList.toggle('activeFilter', matches);
      });
    }
  
    window.ingridFilters.onFilterSelect = function (e) {
      try {
        let filterElement = e.target.closest('.ingrid-filters-container .quickFilter');
        if (!filterElement || filterElement.classList.contains('mobile-facets__label--disabled')) return;
  
        if (filterElement.getAttribute('data-price-slab') === 'true') {
          applyPriceSlab(filterElement);
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return;
        }
  
        let filterAttribute = filterElement.getAttribute('data-quick-filter-value');
        if (filterAttribute == null) return;
  
        let paramName = filterElement.getAttribute('data-filter-param');
        let checkbox = facetCheckboxForValue(filterAttribute, paramName);
        if (checkbox) checkbox.click();
  
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } catch (err) {
        console.error('ingridFilters.onFilterSelect:', err);
      }
    };
  
    window.ingridFilters.selectMyFilter = function () {
      try {
        document.querySelectorAll('.ingrid-filters-container .quickFilter:not([data-price-slab="true"])').forEach(function (x) {
          x.classList.remove('activeFilter');
        });
        document
          .querySelectorAll('input.checkbox__input:checked, input.facets__pill-input:checked')
          .forEach(function (input) {
            let v = input.value;
            let n = input.name;
            if (!v) return;
            document.querySelectorAll('.ingrid-filters-container .quickFilter:not([data-price-slab="true"])').forEach(function (el) {
              if (el.getAttribute('data-quick-filter-value') !== v) return;
              if (n && el.getAttribute('data-filter-param') !== n) return;
              el.classList.add('activeFilter');
            });
          });
        syncPriceSlabActiveState();
      } catch (err) {
        console.error('ingridFilters.selectMyFilter:', err);
      }
    };
  
    document.addEventListener('click', function (e) {
      let chip = e.target.closest('.ingrid-filters-container .quickFilter:not(.mobile-facets__label--disabled)');
      if (chip) window.ingridFilters.onFilterSelect(e);
    });
  
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      let chip = e.target.closest('.ingrid-filters-container .quickFilter:not(.mobile-facets__label--disabled)');
      if (chip) {
        e.preventDefault();
        window.ingridFilters.onFilterSelect(e);
      }
    });
  
    function runInitialSync() {
      window.ingridFilters.selectMyFilter();
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runInitialSync);
    } else {
      runInitialSync();
    }
  
    document.addEventListener('filter:update', function () {
      requestAnimationFrame(function () {
        window.ingridFilters.selectMyFilter();
      });
    });
  
    document.addEventListener('shopify:section:morphed', function () {
      requestAnimationFrame(function () {
        window.ingridFilters.selectMyFilter();
      });
    });
  })();
  